import { is } from '@common/is/is'

import { getRandomId } from '@common/utils/utility'

import styles from './Accordion.css'

interface IProps {
  readonly title: string
  readonly isOpened?: boolean
  readonly children?: unknown
  readonly className?: string
  readonly onChange?: (isOpened: boolean) => void
  readonly isInvalid?: boolean
}

/**
 * Bootstrap accordion wrapper.
 * @see {@link https://getbootstrap.com/docs/5.1/components/accordion/ }
 * @param props - JSX props {@link IProps}.
 */
export default function Accordion (props: IProps): HTMLElement {
  const index = getRandomId()

  const { children, className, isInvalid, isOpened = false, onChange, title } = props

  const accordionClassName: readonly string[] = [
    'accordion',
    className ?? ''
  ]

  const buttonClassName: readonly string[] = [
    'accordion-button',
    isOpened ? '' : 'collapsed',
    isInvalid ? styles.isInvalid : ''
  ]

  /**
   * Ha passzoltunk át onChange callback-et, akkor ezt a függvényt használjuk.
   * @param e - Event.
   */
  function onClick (e: Event): void {
    if (!is.function(onChange)) {
      return
    }

    const btn = e.currentTarget as HTMLElement

    const isOpened = !btn.classList.contains('collapsed')

    onChange(isOpened)
  }

  const accordion: HTMLElement = (
    <div id={ `accordion-${ index }` } className={ accordionClassName }>
      <div className="accordion-item">
        <h2 id={ `heading-${ index }` } className="accordion-header">
          <button
            className={ buttonClassName }
            aria-controls={ `collapse-${ index }` }
            aria-expanded={ isOpened }
            type="button"
            data-bs-target={ `#collapse-${ index }` }
            data-bs-toggle="collapse"
            dangerouslySetInnerHTML={ { __html: title } }
            { ...onChange ? { onClick } : {} }
          />
        </h2>

        <div
          id={ `collapse-${ index }` }
          className={ [ 'accordion-collapse', 'collapse', isOpened ? 'show' : '' ] }
          aria-labelledby={ `heading-${ index }` }
          data-bs-parent={ `#accordion-${ index }` }
        >
          {
            is.array(children) && is.string(children[0])
              ? <div className="accordion-body" dangerouslySetInnerHTML={ { __html: children[0] } } />
              : <div className="accordion-body">{ children }</div>
          }
        </div>
      </div>
    </div>
  )

  return accordion
}
